export default "__VITE_ASSET__DyVY4Bqa__"